var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-b-10"},[_c('maintenanceList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }